/**
 * 功能：新框架vue与原JQuery通信方案
 * 原模JQuery块与vue模块通信统一通过桥接层（状态或方法），vue与原模块JQuery通信统一通过事件机制
 */
import useDiscountDetailsStore from "@shared/store/useDiscountDetailsStore";
import usePrivateStore from "@shared/store/usePrivateStore";
import EventEmitter from "eventemitter3";

const ee = new EventEmitter();

const Bridge = {
  /**
   * 事件类型定义
   */
  EventType: {
    renderCart: "renderCart",
  },

  on(event, callback) {
    return ee.addListener(event, callback);
  },

  emit(event, data) {
    return ee.emit(event, data);
  },

  off(event, callback) {
    return ee.removeListener(event, callback);
  },

  /**
   * 折扣弹窗显示/隐藏切换
   */
  toggleDiscountPopup(value) {
    const { toggle } = useDiscountDetailsStore();
    toggle(value);
  },
   /**
   * 拿私定store
   */
  getPrivate(){
    const store = usePrivateStore();
    return store;
  },
};

export { Bridge };
